import { Component, Input, OnInit, signal } from '@angular/core';
import { ModalService } from 'mis-crystal-design-system/modal';
import { CommonService } from 'src/app/trip-view/services/common.service';
import { DatePipe } from '@angular/common';
import { CommonCabService, ITicketDetails } from 'src/app/trip-view-cab/services/common-cab.service';
import { DeviceHealthComponentCab } from '../../device-health/device-health.component';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
import { DateUtils } from 'src/app/utils/days-utils';
@Component({
  selector: 'app-trip-info-card',
  templateUrl: './trip-info-card.component.html',
  styleUrls: ['./trip-info-card.component.scss']
})
export class TripInfoCardComponent implements OnInit {
  imgSrc: string;
  constructor(private testPopup: ModalService, private commonService: CommonService, private commonCabService: CommonCabService, private envService: EnvironmentService) { }

  initialState = { type: 'SHUTTLE' }
  response: any;
  formattedShiftDate: any;
  formattedActualStartTime: any;
  formattedActualStartDate: any;
  formattedPlannedStartTime: any;
  formattedStartDate: any;
  formattedEndDate: any;
  formattedActualEndTime: any;
  formattedPlannedEndTime: any;
  shiftDate: any;
  actualStartTime: any;
  actualEndTime: any;
  plannedStartTime: any;
  plannedEndTime: any;
  direction: any;
  womenTravellingAlone = false;
  ticketDetails:ITicketDetails[] = [];
  isTripCompleted=signal<boolean>(false);
  @Input() tripId:any;
  @Input() routeSource:any;
  @Input() dir:any;
  @Input() isTripExpired:any;
  INFO_ICON:any;
  tripStatusTitle:any = 'STATUS UNAVAILABLE';
  tripStatusMessage:any = 'Trip status is unavailable';

  ngOnInit(): void {
    this.imgSrc = this.envService.getImgSrc();
    this.INFO_ICON = `${this.imgSrc}assets/icons/info_icon.svg`;
    this.response = this.commonCabService.response
    this.ticketDetails = this.commonCabService.ticketDetails
    this.shiftDate = this.response.tripDetails.shift.date;
    this.actualStartTime = this.response.tripDetails.actualStartTime;
    this.actualEndTime = this.response.tripDetails.actualEndTime;
    this.plannedStartTime = this.response.tripDetails.plannedStartTime;
    this.plannedEndTime = this.response.tripDetails.plannedEndTime;
    this.isTripCompleted.set(this.response.tripDetails.status === 'Ended');


    this.formattedShiftDate = DateUtils.formatTimeWithZone(this.shiftDate, this.commonCabService.timeZone, 'ddd DD MMM, HH:mm');
    this.formattedStartDate = DateUtils.formatDate(this.actualStartTime, 'DD MMM,YY');
    this.formattedActualStartDate =DateUtils.formatDateTime(this.actualStartTime,'ddd DD MMM, HH:mm');
    this.formattedActualEndTime = DateUtils.formatTimeWithZone(this.actualEndTime, this.commonCabService.timeZone, 'HH:mm');
    this.formattedActualStartTime = DateUtils.formatTimeWithZone(this.actualStartTime, this.commonCabService.timeZone, 'HH:mm');
    this.formattedEndDate = DateUtils.formatDate(this.actualEndTime, 'DD MMM,YY');
    this.formattedPlannedStartTime = DateUtils.formatTimeWithZone(this.plannedStartTime, this.commonCabService.timeZone, 'HH:mm');
    this.formattedPlannedEndTime = DateUtils.formatTimeWithZone(this.plannedEndTime, this.commonCabService.timeZone, 'HH:mm');
    this.direction = this.response.tripDetails.direction;

    if (!this.response.tripDetails.driver.driverImagePath) {
        this.response.tripDetails.driver.driverImagePath = `${this.imgSrc}assets/icons/driver-profile.svg`;
    }

    this.commonService.womenTravellingAlone$.subscribe((res) => {
        this.womenTravellingAlone = res;
    });
    this.tripStatus(this.tripId);
}

  tripStatus(tripId: string) {
    if (this.routeSource == "SHUTTLE_SERVICE" && this.dir === 'OUT' && this.isTripExpired) {
      this.tripStatusTitle = 'TRIP EXPIRED';
      this.tripStatusMessage = 'Trip has expired';
    }
    else {
      this.commonService.getTripStatus(tripId).subscribe(
        (res: any) => {
          this.tripStatusTitle = res.tripStatus || 'STATUS UNAVAILABLE';
          this.tripStatusMessage = res.message || 'Trip status is unavailable';
        },
        (error) => {
          this.tripStatusTitle = 'STATUS UNAVAILABLE';
          this.tripStatusMessage = 'Trip status is unavailable';
        }
      );
    }
  }

  getTripStatusClass() {
    switch (this.tripStatusTitle) {
        case 'TRIP EXPIRED':
            return 'status-expired';
        case 'STATUS UNAVAILABLE':
            return 'status-expired';
        case 'TRIP IN PROGRESS':
            return 'status-in-progress';
        case 'TRIP COMPLETED':
            return 'status-in-progress';
        case 'TRIP DELETED':
            return 'status-deleted';
        case 'TRIP CANCELLED':
            return 'status-deleted';
        case 'TRIP MARKED NO SHOW':
            return 'status-deleted';
        case 'TRIP NOT DOWNLOADED':
            return 'status-not-downloaded';
        case 'VEHICLE NOT ASSIGNED':
            return 'status-not-downloaded';
        case 'TRIP DOWNLOADED ON DEVICE':
            return 'status-downloaded-on-device';
        case 'TRIP DISPLAYED ON DEVICE':
            return 'status-downloaded-on-device';
        default:
            return 'status';
    }
}


  openDeviceHealthModal() {
    this.testPopup.show(DeviceHealthComponentCab, { closeOnBackdropClick: true, ...this.initialState });
  }
  openTicketDetails(ticketUrl:string){
    window.open(ticketUrl, '_blank')
  }


}
